import React, { useContext, useEffect, useState } from "react";
import { csrfToken } from "../../../../utils/csrfTokenUtils";
import { networkService } from "../../../config/axios";
import CustomForm from "../../../CommonComponents/CustomForm/CustomForm";
import UserInfoContext from "../../../../utils/userInfoContext";
import { AdminFormInput, AdminModalFooter } from "../../../Admin/Shared";

const AddPaymentSection = ({ setShow, companyId, paymentData }) => {
  const { setShowNotifications } = useContext(UserInfoContext);

  const initialState = {
    amount: "",
    currency: "",
    start_date: "",
    end_date: "",
  };

  const [payment, setPayment] = useState(initialState)
  const [error, setError] = useState({})
  const today = new Date().toISOString().split('T')[0];

  const handleChange = ({ target: { name, value, type } }) => {
    if (type === "date") {
      let formattedDate = new Date(value);
      value = formattedDate.toISOString();
    }
    setError({
      [name]: "",
    });
    setPayment({
      ...payment,
      [name]: value,
    });
  };

  const handleValidations = (payment) => {
    let hasError = false;
    const newErrors = {};

    if (!payment?.amount) {
      newErrors.amount = "Please add the amount";
      hasError = true;
    }
    if (!payment?.currency) {
      newErrors.currency = "Please add the currency";
      hasError = true;
    }
    if (!payment?.start_date) {
      newErrors.start_date = 'Please enter the start date';
      hasError = true;
    } else if (payment?.start_date < today) {
      hasError = true;
      newErrors.start_date = 'please select a valid date'
    }
    if (!payment?.end_date) {
      newErrors.end_date = 'Please enter the end date';
      hasError = true;
    } else if (payment?.end_date < today) {
      hasError = true;
      newErrors.end_date = 'please select a valid date'
    }
    if (hasError) {
      setError({ ...error, ...newErrors });
      return false;
    } else {
      return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidations(payment)) {
      const data = {
        authenticity_token: csrfToken(),
        ...(payment?.id && { id: payment?.id }),
        payment: {
          amount: payment?.amount,
          currency: payment?.currency,
          start_date: payment?.start_date,
          end_date: payment?.end_date,
          company_id: companyId,
        },
      };
      const url = payment?.id
        ? `admin/company_payments/${payment?.id}.json`
        : "admin/company_payments.json";
      await networkService(url, payment?.id ? "PATCH" : "POST", data)
        .then((response) => {
          if (response?.status === 201 || response?.status == 200) {
            setShow("list");
            setShowNotifications({
              showToast: true,
              toastType: "success",
              toastMessage: `Payment ${payment?.id ? "updated" : "added"}`,
            });
            setPayment(initialState);
          }
        })
        .catch((err) => {
          console.error(err);
          setShowNotifications({
            showToast: true,
            toastType: 'danger',
            toastMessage: "Something went wrong"
          })
        });
    }
  };

  useEffect(() => {
    if (paymentData?.id) {
      setPayment(paymentData);
    } else {
      setPayment(initialState);
    }
  }, [paymentData]);

  return (
    <div className="payment-form-container" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <CustomForm className="org-form-pop">
        <div className="form-row">
          <AdminFormInput
            label="Amount"
            name="amount"
            type="number"
            value={payment?.amount}
            onChange={handleChange}
            error={error?.amount}
            required={true}
            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
          />
          <AdminFormInput
            label="Currency"
            name="currency"
            value={payment?.currency}
            onChange={handleChange}
            error={error?.currency}
            required={true}
          />
        </div>

        <div className="admin-form-row mt-3">
          <AdminFormInput
            label="From Date"
            name="start_date"
            type="date"
            value={
              payment?.start_date
                ? payment?.start_date?.split("T")[0].split(" ")[0]
                : ""
            }
            onChange={handleChange}
            error={error?.start_date}
            required={true}
            min={today}
          />
          <AdminFormInput
            label="To Date"
            name="end_date"
            type="date"
            value={
              payment?.end_date
                ? payment?.end_date?.split("T")[0].split(" ")[0]
                : ""
            }
            onChange={handleChange}
            error={error?.end_date}
            required={true}
            min={today}
          />
        </div>

        <AdminModalFooter
          onCancel={() => {
            setShow("list");
            setPayment(initialState);
          }}
          onSubmit={handleSubmit}
          submitText={payment?.id ? "Update" : "Save"}
        />
      </CustomForm>
    </div>
  );
};

export default AddPaymentSection;
